import React from 'react';
import { titleCase, get } from "@dex/bubl-helpers";
import PushNotificationApi from './PushNotificationApi';
import PushNotificationActions from './Components/PushNotificationActions';

let settings;

export default settings = {
    key: 'content/notifications',
    zone: 'content',
    path: '/content/notifications',
    title: "Push Notification",
    endpoint: PushNotificationApi.endpoint,
    modelName: 'PushNotification',
    idKey: 'id',
    primaryKey: 'id',
    indexCaps: ["viewPushNotification"],
    viewCaps: ["viewPushNotification"],
    createCaps: ["createPushNotification"],
    indexTitle: (routeName, params, users) => {

        let title: string = settings.title;

        if (params && params.name) title = title + " / " + titleCase(params.name);

        return title;

    },
    indexTabs: (routeName, params, users) => {

        return [
            {
                label: "All",
                path: settings.path,
                caps: settings.indexCaps
            },
            {
                label: "Add New",
                path: settings.path + "/create",
                caps: settings.createCaps
            },
        ]

    },
    indexButtons: (routeName, params, users) => {

        return [
            {
                label: "Add New",
                path: settings.path + '/create',
                caps: settings.createCaps
            }
        ]

    },
    indexTabCounts: (routeName, params, dontation) => {

        return settings.endpoint + "/getCounts";

    },
    indexFetch: PushNotificationApi.get,
    indexFetchParams: (routeName, params, users) => {

        const filters: any = { where: {}, include: ['sentBy', 'users'], order: ['created.date DESC'], limit: 10, skip: 0 };

        if (params && params.status) filters.where.status = { inq: [params.status] };

        return filters;

    },
    indexQuickSearch: (routeName, params, users) => {

        const fields = ['id'];

        return fields;

    },
    indexSearchFields: (routeName, params, users) => {

        const fields = [
            {
                label: "ID",
                key: "id",
                type: "text",
            },
        ];

        return fields;

    },

    indexColumns: (routeName, params, users) => {

        const columns = [
            {
                label: "ID",
                key: "this",
                format: "ModelLink",
            },
            {
                label: "Status",
                key: "status",
                format: 'titleCase'
            },
            {
                label: "Title",
                key: "title",
            },
            {
                label: "Topic",
                key: "topic",
                format: "titleCase"
            },
            {
                label: "Send To",
                key: "to",
                format: "titleCase"
            },
            {
                label: "Created Date",
                key: "created",
                format: "OnAndBy",
                sort: "created.date",
                alignEnd: true
            },
            {
                label: "Actions",
                key: "actions",
                alignEnd: true,
                render: (value, data) => {

                    return <PushNotificationActions data={data} />;

                }
            }
        ];

        return columns;

    },
    singleFetch: PushNotificationApi.getOne,
    singleFetchParams: (routeName, params, users, fetch) => {

        const filters = { include: ['sentBy', 'users'] };

        return filters;

    },
    singleTitle: (routeName, params, users, fetch) => {

        let title: string = "Loading...";

        const complete = get(fetch, 'complete');
        const error = get(fetch, 'error');
        const data = get(fetch, 'data');

        if (error) title = "Error";
        else if (data) title = data[settings.primaryKey];
        else if (complete && !data) title = "Not Found";

        return title;

    },
    singleTabs: (routeName, params, users, fetch) => {

        const path = settings.path + "/" + params.id;

        return [
            {
                label: "View",
                path: path + "/view"
            },
            {
                label: "Edit",
                path: path + "/edit"
            },
        ]

    },
};